<template>
  <div>
    <div v-if="isEditor">
      <Row :gutter="4">
        <h5>{{ label }}</h5>
        <div style="font-size: 12px;">
          {{ $t('static_translation.anzahl-der-personen') }} ({{ $t('static_translation.erwachsene') }}, {{ $t('static_translation.kinder') }})
        </div>
        <Col span="11">
        <Row :gutter="4">
          <Col span="5">
          <FormItem>
            <InputNumber
              v-model.trim="myValue.adults"
              :min="0"
              :placeholder="$t('static_translation.erwachsene')"
              style="width:100%;"
              @on-blur="emitValue"
            />
          </FormItem>
          </Col>
          <Col span="5">
          <FormItem>
            <InputNumber
              v-model.trim="myValue.childs"
              :placeholder="$t('static_translation.kinder')"
              :min="0"
              style="width:100%;"
              @on-blur="emitValue"
            />
          </FormItem>
        </Col>
          <Col span="14">
          <FormItem>
            <Input
              v-model.trim="myValue.value"
              :placeholder="$t('static_translation.alter-der-kinder')"
              @on-blur="emitValue"
            >
            </Input>
          </Formitem>
         </Col>
        </Row>
      </Col>
      </Row>
    </div>
    <div v-else>
      <dl
        v-if="myValue && myValue.adults || myValue.childs"
        class="uk-description-list"
      >
        <dt>{{ label }}</dt>
        <dd>
          {{ myValue.adults }} {{ $t('static_translation.erwachsene') }},
          {{ myValue.childs }} {{ $t('static_translation.kinder') }}
          ({{ $t('static_translation.alter-der-kinder') }}: {{ myValue.value }})
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { strings, booleans, numbers, objects } from '@/mixins/props/defaults'

export default {
  mixins: [
    strings('label'),
    numbers('extraId'),
    booleans('isEditor'),
    objects('otherParams', 'value')
  ],
  data () {
    return {
      myValue: {
        adults: 0,
        childs: 0,
        value: ''
      },
      placeholder: ''
    }
  },
  mounted () {
    if (this.value) {
      this.myValue = this.value
    }
  },
  methods: {
    emitValue () {
      const payload = {
        id: this.extraId,
        value: this.myValue.value || null,
        adults: this.myValue.adults || null,
        childs: this.myValue.childs || null
      }
      this.$emit('value-changed', payload)
    }
  }
}
</script>
